@if (isScriptLoaded) {
  <ng-content></ng-content>
}
